/* ==========================================================================
   DeVAR SHOPFRONT INTERACTIONS MASTER SCRIPT
   ========================================================================== */

// Global Wishlist Key & Shipping Threshold
const WISHLIST_STORAGE_KEY = 'devar_wishlist_v1';
const FREE_SHIPPING_THRESHOLD = 2000;

document.addEventListener('DOMContentLoaded', () => {
  initAJAXCart();
  initMegaMenu();
  initSearchOverlay();
  initAccordions();
  initWishlistSystem();
  initProductHotspots();
  initProductVariants();
  initDrawerTriggers();
});

/**
 * AJAX Cart Drawer & Cart Logic
 */
let cartState = {
  items: [],
  subtotal: 0,
  discount: 0,
  total: 0
};

// Check if running on real Shopify storefront or local mock server
const IS_SHOPIFY = typeof Shopify !== 'undefined' && Shopify.shop;

// Load initial state or simulation data
if (!IS_SHOPIFY && localStorage.getItem('devar_cart')) {
  try {
    cartState = JSON.parse(localStorage.getItem('devar_cart'));
  } catch (e) {
    console.warn("Resetting corrupt cart state");
  }
}

function saveCartState() {
  if (!IS_SHOPIFY) {
    localStorage.setItem('devar_cart', JSON.stringify(cartState));
    updateCartUI();
    document.dispatchEvent(new CustomEvent('cartUpdated', { detail: cartState }));
  }
}

function initAJAXCart() {
  // Listen for AJAX Quick Adds
  document.addEventListener('click', (e) => {
    const quickAddBtn = e.target.closest('[data-quick-add]');
    if (quickAddBtn) {
      e.preventDefault();
      const variantId = quickAddBtn.getAttribute('data-product-id');
      
      if (IS_SHOPIFY) {
        addShopifyProduct(variantId, 1);
      } else {
        const productData = getProductDataFromAttributes(quickAddBtn);
        addProductToCart(productData);
      }
    }
  });

  // Drawer quantity controls
  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      const key = qtyBtn.getAttribute('data-key');
      const index = parseInt(qtyBtn.getAttribute('data-index'));
      const delta = parseInt(qtyBtn.getAttribute('data-cart-qty'));
      
      if (IS_SHOPIFY) {
        const currentItem = cartState.items.find(item => item.key === key || item.id === key);
        if (currentItem) {
          updateShopifyCartQty(key, currentItem.quantity + delta);
        }
      } else {
        updateCartItemQuantity(index, delta);
      }
    }

    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      const key = removeBtn.getAttribute('data-key');
      const index = parseInt(removeBtn.getAttribute('data-index'));
      
      if (IS_SHOPIFY) {
        updateShopifyCartQty(key, 0);
      } else {
        removeCartItem(index);
      }
    }
  });

  // Form submission interceptor for product detail form
  const productForm = document.querySelector('.shopify-product-form');
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      if (IS_SHOPIFY) {
        e.preventDefault();
        const variantEl = document.getElementById('selected-variant-id');
        const qtyEl = document.getElementById('product-quantity-input');
        if (variantEl) {
          const variantId = variantEl.value;
          const qty = qtyEl ? (parseInt(qtyEl.value) || 1) : 1;
          addShopifyProduct(variantId, qty);
        }
      }
    });
  }

  if (IS_SHOPIFY) {
    refreshShopifyCart();
  } else {
    updateCartUI();
  }
}

function updateShopifyCartQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: qty
    })
  })
  .then(res => res.json())
  .then(() => {
    refreshShopifyCart();
  })
  .catch(err => console.error("Error updating cart quantity:", err));
}

function addShopifyProduct(variantId, qty = 1) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: qty
      }]
    })
  })
  .then(res => res.json())
  .then(() => {
    refreshShopifyCart();
    openCartDrawer();
  })
  .catch(err => console.error("Error adding product to cart:", err));
}

function refreshShopifyCart() {
  fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    cartState.items = cart.items.map(item => ({
      id: item.variant_id.toString(),
      key: item.key,
      title: item.product_title,
      price: item.price / 100.0,
      comparePrice: item.original_price / 100.0,
      image: item.image,
      variant: item.variant_title || '',
      quantity: item.quantity
    }));
    cartState.subtotal = cart.original_total_price / 100.0;
    cartState.discount = cart.total_discount / 100.0;
    cartState.total = cart.total_price / 100.0;
    
    updateCartUI();
  })
  .catch(err => console.error("Error loading cart details:", err));
}

function getProductDataFromAttributes(element) {
  return {
    id: element.getAttribute('data-product-id') || Date.now().toString(),
    title: element.getAttribute('data-product-title') || 'Luxury Product',
    price: parseFloat(element.getAttribute('data-product-price')) || 9999,
    comparePrice: parseFloat(element.getAttribute('data-product-compare-price')) || 0,
    image: element.getAttribute('data-product-image') || '',
    variant: element.getAttribute('data-product-variant') || 'Standard Edition',
    quantity: 1
  };
}

function addProductToCart(product) {
  const existingItemIndex = cartState.items.findIndex(item => item.id === product.id && item.variant === product.variant);

  if (existingItemIndex > -1) {
    cartState.items[existingItemIndex].quantity += 1;
  } else {
    cartState.items.push(product);
  }

  recalculateCart();
  saveCartState();
  openCartDrawer();
}

function updateCartItemQuantity(index, delta) {
  if (!cartState.items[index]) return;
  
  cartState.items[index].quantity += delta;
  
  if (cartState.items[index].quantity <= 0) {
    cartState.items.splice(index, 1);
  }

  recalculateCart();
  saveCartState();
}

function removeCartItem(index) {
  if (!cartState.items[index]) return;
  cartState.items.splice(index, 1);
  recalculateCart();
  saveCartState();
}

function recalculateCart() {
  cartState.subtotal = cartState.items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  
  // Luxury Discount Calculation (e.g. coupon simulation)
  cartState.discount = cartState.subtotal > 20000 ? Math.floor(cartState.subtotal * 0.08) : 0;
  cartState.total = cartState.subtotal - cartState.discount;
}

function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('drawer-overlay');
  if (drawer && overlay) {
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }
}

function closeAllDrawers() {
  const activeDrawers = document.querySelectorAll('.drawer.active');
  const overlay = document.getElementById('drawer-overlay');
  const searchOverlay = document.getElementById('search-overlay');
  
  activeDrawers.forEach(drawer => drawer.classList.remove('active'));
  if (overlay) overlay.classList.remove('active');
  if (searchOverlay) searchOverlay.classList.remove('active');
  
  document.body.classList.remove('overflow-hidden');
  document.querySelector('.luxury-header-sticky')?.classList.remove('drawer-open');
}

function updateCartUI() {
  const counters = document.querySelectorAll('.cart-count');
  const drawerList = document.querySelector('.cart-drawer-list');
  const subtotalElems = document.querySelectorAll('.cart-subtotal');
  const totalElems = document.querySelectorAll('.cart-total');
  const discountElems = document.querySelectorAll('.cart-discount');
  const shippingBar = document.querySelector('.shipping-progress-fill');
  const shippingText = document.querySelector('.shipping-progress-text');
  
  const totalItemsCount = cartState.items.reduce((sum, item) => sum + item.quantity, 0);

  // Update counters
  counters.forEach(counter => {
    counter.textContent = totalItemsCount;
    if (counter.classList.contains('action-badge')) {
      counter.style.display = totalItemsCount > 0 ? 'flex' : 'none';
    } else {
      counter.style.display = totalItemsCount > 0 ? 'inline' : 'none';
    }
  });

  // Calculate B2B / B2C prices dynamically
  const isB2B = localStorage.getItem('devar-shopping-mode') === 'business';
  let computedSubtotal = 0;
  let computedDiscount = 0;
  let computedTotal = 0;
  
  cartState.items.forEach(item => {
    const itemTotalB2C = item.price * item.quantity;
    let itemDiscountPercent = 0;
    
    if (isB2B) {
      if (item.quantity >= 50) itemDiscountPercent = 50;
      else if (item.quantity >= 20) itemDiscountPercent = 40;
      else if (item.quantity >= 10) itemDiscountPercent = 35;
      else itemDiscountPercent = 30;
    }
    
    const itemDiscount = itemTotalB2C * (itemDiscountPercent / 100);
    computedSubtotal += itemTotalB2C;
    computedDiscount += itemDiscount;
    computedTotal += (itemTotalB2C - itemDiscount);
  });

  // Local currency converters matching shopping-switch.js
  const targetCountry = localStorage.getItem('devar-selected-country') || 'IN';
  const localCountryToCurrencyMap = {
    "AF": "AFN", "AX": "EUR", "AL": "ALL", "DZ": "DZD", "AD": "EUR", "AO": "AOA", "AI": "XCD", "AG": "XCD", "AR": "ARS", "AM": "AMD",
    "AW": "AWG", "AU": "AUD", "AT": "EUR", "AZ": "AZN", "BS": "BSD", "BH": "BHD", "BD": "BDT", "BB": "BBD", "BY": "BYN", "BE": "EUR",
    "BZ": "BZD", "BJ": "XOF", "BM": "BMD", "BT": "BTN", "BO": "BOB", "BA": "BAM", "BW": "BWP", "BR": "BRL", "IO": "USD", "VG": "USD",
    "BN": "BND", "BG": "BGN", "BF": "XOF", "BI": "BIF", "KH": "KHR", "CM": "XAF", "CA": "CAD", "CV": "CVE", "KY": "KYD", "CF": "XAF",
    "TD": "XAF", "CL": "CLP", "CN": "CNY", "CX": "AUD", "CC": "AUD", "CO": "COP", "KM": "KMF", "CG": "XAF", "CD": "CDF", "CK": "NZD",
    "CR": "CRC", "CI": "XOF", "HR": "EUR", "CU": "CUP", "CW": "ANG", "CY": "EUR", "CZ": "CZK", "DK": "DKK", "DJ": "DJF", "DM": "XCD",
    "DO": "DOP", "EC": "USD", "EG": "EGP", "SV": "USD", "GQ": "XAF", "ER": "ERN", "EE": "EUR", "SZ": "SZL", "ET": "ETB", "FK": "FKP",
    "FO": "DKK", "FJ": "FJD", "FI": "EUR", "FR": "EUR", "GF": "EUR", "PF": "XPF", "TF": "EUR", "GA": "XAF", "GM": "GMD", "GE": "GEL",
    "DE": "EUR", "GH": "GHS", "GI": "GIP", "GR": "EUR", "GL": "DKK", "GD": "XCD", "GP": "EUR", "GT": "GTQ", "GG": "GBP", "GN": "GNF",
    "GW": "XOF", "GY": "GYD", "HT": "HTG", "HN": "HNL", "HK": "HKD", "HU": "HUF", "IS": "ISK", "IN": "INR", "ID": "IDR", "IQ": "IQD",
    "IE": "EUR", "IM": "GBP", "IL": "ILS", "IT": "EUR", "JM": "JMD", "JP": "JPY", "JE": "GBP", "JO": "JOD", "KZ": "KZT", "KE": "KES",
    "KI": "AUD", "KP": "KPW", "KR": "KRW", "KW": "KWD", "KG": "KGS", "LA": "LAK", "LV": "EUR", "LB": "LBP", "LS": "LSL", "LR": "LRD",
    "LY": "LYD", "LI": "CHF", "LT": "EUR", "LU": "EUR", "MO": "MOP", "MG": "MGA", "MW": "MWK", "MY": "MYR", "MV": "MVR", "ML": "XOF",
    "MT": "EUR", "MQ": "EUR", "MR": "MRU", "MU": "MUR", "YT": "EUR", "MX": "MXN", "FM": "USD", "MD": "MDL", "MC": "EUR", "MN": "MNT",
    "ME": "EUR", "MS": "XCD", "MA": "MAD", "MZ": "MZN", "MM": "MMK", "NA": "NAD", "NR": "AUD", "NP": "NPR", "NL": "EUR", "NC": "XPF",
    "NZ": "NZD", "NI": "NIO", "NE": "XOF", "NG": "NGN", "NU": "NZD", "NF": "AUD", "MP": "USD", "NO": "NOK", "OM": "OMR", "PK": "PKR",
    "PW": "USD", "PS": "ILS", "PA": "PAB", "PG": "PGK", "PY": "PYG", "PE": "PEN", "PH": "PHP", "PN": "NZD", "PL": "PLN", "PT": "EUR",
    "PR": "USD", "QA": "QAR", "RE": "EUR", "RO": "RON", "RU": "RUB", "RW": "RWF", "WS": "WST", "SM": "EUR", "ST": "STN", "SA": "SAR",
    "SN": "XOF", "RS": "RSD", "SC": "SCR", "SL": "SLL", "SG": "SGD", "SX": "ANG", "SK": "EUR", "SI": "EUR", "SB": "SBD", "SO": "SOS",
    "ZA": "ZAR", "GS": "GBP", "SS": "SSP", "ES": "EUR", "LK": "LKR", "BL": "EUR", "SH": "SHP", "KN": "XCD", "LC": "XCD", "MF": "EUR",
    "PM": "EUR", "VC": "XCD", "SD": "SDG", "SR": "SRD", "SJ": "NOK", "SE": "SEK", "CH": "CHF", "SY": "SYP", "TW": "TWD", "TJ": "TJS",
    "TZ": "TZS", "TH": "THB", "TL": "USD", "TG": "XOF", "TK": "NZD", "TO": "TOP", "TT": "TTD", "TA": "GBP", "TN": "TND", "TR": "TRY",
    "TM": "TMT", "TC": "USD", "TV": "AUD", "UM": "USD", "UG": "UGX", "UA": "UAH", "AE": "AED", "GB": "GBP", "US": "USD", "UY": "UYU",
    "UZ": "UZS", "VU": "VUV", "VE": "VES", "VN": "VND", "WF": "XPF", "EH": "MAD", "YE": "YER", "ZM": "ZMW", "ZW": "ZWL"
  };

  const localCurrencySymbols = {
    "USD": "$", "EUR": "€", "GBP": "£", "AUD": "A$", "CAD": "C$", "JPY": "¥", "INR": "₹", "AED": "د.إ", "SAR": "ر.س", "AFN": "؋",
    "ALL": "L", "DZD": "DA", "AOA": "Kz", "ARS": "$", "AMD": "֏", "BDT": "৳", "BHD": "BD", "BIF": "FBu", "BMD": "$", "BND": "$",
    "BOB": "Bs", "BAM": "KM", "BWP": "P", "BRL": "R$", "KHR": "៛", "CVE": "$", "CLP": "$", "CNY": "¥", "COP": "$", "KMF": "CF",
    "CDF": "FC", "CRC": "₡", "CZK": "Kč", "DKK": "kr", "DJF": "Fdj", "DOP": "RD$", "EGP": "EGP", "ETB": "Br", "FKP": "£", "FJD": "$",
    "GMD": "D", "GEL": "₾", "GHS": "GH₵", "GIP": "£", "GTQ": "Q", "GNF": "FG", "GYD": "$", "HTG": "G", "HNL": "L", "HKD": "$",
    "HUF": "Ft", "ISK": "kr", "IDR": "Rp", "ILS": "₪", "JMD": "J$", "JOD": "JD", "KZT": "₸", "KES": "KSh", "KWD": "KD", "KGS": "сом",
    "LAK": "₭", "LBP": "L£", "LSL": "L", "LRD": "$", "LYD": "LD", "MOP": "MOP$", "MGA": "Ar", "MWK": "MK", "MYR": "RM", "MVR": "Rf",
    "MRU": "UM", "MUR": "₨", "MXN": "$", "MDL": "L", "MNT": "₮", "MAD": "DH", "MZN": "MT", "MMK": "K", "NAD": "$", "NPR": "₨",
    "NZD": "$", "NIO": "C$", "NGN": "₦", "NOK": "kr", "OMR": "RO", "PKR": "₨", "PAB": "B/.", "PGK": "K", "PYG": "₲", "PEN": "S/.",
    "PHP": "₱", "PLN": "zł", "QAR": "QR", "RON": "lei", "RUB": "₽", "RWF": "FRw", "WST": "T", "STN": "Db", "RSD": "din", "SCR": "₨",
    "SLL": "Le", "SGD": "$", "SOS": "Sh", "ZAR": "R", "LKR": "Rs", "SSP": "£", "SEK": "kr", "CHF": "CHF", "TWD": "NT$", "TJS": "SM",
    "TZS": "TSh", "THB": "฿", "TOP": "T$", "TTD": "TT$", "TND": "DT", "TRY": "₺", "UGX": "USh", "UAH": "₴", "UYU": "$U", "UZS": "so'm",
    "VUV": "VT", "VES": "Bs.S", "VND": "₫", "YER": "﷼", "ZMW": "ZK", "XCD": "$"
  };

  const targetCurrency = localCountryToCurrencyMap[targetCountry] || 'INR';
  const symbol = localCurrencySymbols[targetCurrency] || '₹';
  
  // Get active exchange rate from sessionStorage
  let rate = 1.0;
  const cachedRates = sessionStorage.getItem('devar-exchange-rates');
  if (cachedRates) {
    const parsedRates = JSON.parse(cachedRates);
    if (parsedRates && parsedRates[targetCurrency]) {
      rate = parsedRates[targetCurrency];
    }
  }

  const convertVal = (inrAmount) => {
    const val = inrAmount * rate;
    return targetCurrency === 'JPY' ? Math.round(val).toLocaleString() : val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // Render items in cart drawer list
  if (drawerList) {
    if (cartState.items.length === 0) {
      drawerList.innerHTML = `
        <div class="cart-empty-state text-center" style="padding: var(--spacing-xl) 0;">
          <p class="body-sub" style="margin-bottom: var(--spacing-md);">Your shopping bag is empty.</p>
          <a href="/collections/all" class="btn btn-secondary btn-full">Continue Shopping</a>
        </div>
      `;
    } else {
      drawerList.innerHTML = cartState.items.map((item, index) => {
        let itemDiscountPercent = 0;
        let itemPrice = item.price;
        
        if (isB2B) {
          if (item.quantity >= 50) itemDiscountPercent = 50;
          else if (item.quantity >= 20) itemDiscountPercent = 40;
          else if (item.quantity >= 10) itemDiscountPercent = 35;
          else itemDiscountPercent = 30;
          
          itemPrice = item.price * (1 - itemDiscountPercent / 100);
        }
        
        const badgeHtml = isB2B ? '<span style="font-size: 0.55rem; font-weight: 700; background: var(--color-accent-gold); color: #fff; padding: 2px 5px; border-radius: 3px; text-transform: uppercase; margin-left: 6px;">B2B</span>' : '';
        const discountTagHtml = isB2B ? `<span style="font-size: 0.65rem; color: #2e7d32; font-weight: 600; margin-top: 2px; display: block;">✓ Wholesale (${itemDiscountPercent}% Off)</span>` : '';
        
        // Convert item line price to selected currency
        const lineInrPrice = itemPrice * item.quantity;
        const lineFormattedPrice = `${symbol} ${convertVal(lineInrPrice)}`;
        
        return `
        <div class="cart-item" style="display: flex; gap: var(--spacing-md); padding: var(--spacing-md) 0; border-bottom: 1px solid var(--color-border);">
          <div style="width: 70px; aspect-ratio: 1; overflow: hidden; border: 1px solid var(--color-border);">
            <img src="${item.image || 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&q=80&w=200'}" style="width: 100%; height: 100%; object-fit: cover;">
          </div>
          <div style="flex: 1; display: flex; flex-direction: column;">
            <div style="display: flex; align-items: flex-start; justify-content: space-between; flex-wrap: wrap;">
              <span style="font-size: var(--font-size-sm); font-weight: 500;">${item.title}</span>
              ${badgeHtml}
            </div>
            <span class="body-sub" style="font-size: 0.75rem;">${item.variant}</span>
            ${discountTagHtml}
            <div style="display: flex; align-items: center; justify-content: space-between; margin-top: auto;">
              <div style="display: flex; border: 1px solid var(--color-border); align-items: center;">
                <button data-cart-qty="-1" data-key="${item.key || item.id}" data-index="${index}" style="padding: 2px 8px; font-weight: bold;">-</button>
                <span style="padding: 0 10px; font-size: var(--font-size-sm);">${item.quantity}</span>
                <button data-cart-qty="1" data-key="${item.key || item.id}" data-index="${index}" style="padding: 2px 8px; font-weight: bold;">+</button>
              </div>
              <span style="font-size: var(--font-size-sm); font-weight: 600;">${lineFormattedPrice}</span>
            </div>
          </div>
          <button data-cart-remove="true" data-key="${item.key || item.id}" data-index="${index}" style="color: var(--color-text-secondary); height: fit-content;">✕</button>
        </div>
        `;
      }).join('');
    }
  }

  // Update cart page item row prices dynamically (B2B + Currency)
  const cartPageRows = document.querySelectorAll('.cart-item-row');
  cartPageRows.forEach((row, index) => {
    const key = row.getAttribute('data-key');
    const item = cartState.items.find(i => i.key === key || i.id === key);
    if (item) {
      let itemDiscountPercent = 0;
      let itemPrice = item.price;
      
      if (isB2B) {
        if (item.quantity >= 50) itemDiscountPercent = 50;
        else if (item.quantity >= 20) itemDiscountPercent = 40;
        else if (item.quantity >= 10) itemDiscountPercent = 35;
        else itemDiscountPercent = 30;
        
        itemPrice = item.price * (1 - itemDiscountPercent / 100);
      }
      
      // Update B2B badge inside cart page rows details
      let badge = row.querySelector('.cart-item-b2b-badge');
      if (isB2B) {
        if (!badge) {
          const titleWrap = row.querySelector('.cart-item-details-wrapper > a');
          if (titleWrap) {
            badge = document.createElement('span');
            badge.className = 'cart-item-b2b-badge';
            badge.style = 'font-size: 0.55rem; font-weight: 700; background: var(--color-accent-gold); color: #fff; padding: 2px 5px; border-radius: 3px; text-transform: uppercase; margin-left: 6px; display: inline-block;';
            badge.textContent = 'B2B';
            titleWrap.parentNode.insertBefore(badge, titleWrap.nextSibling);
          }
        }
      } else {
        if (badge) badge.remove();
      }
      
      // Update discount label in row details
      let discountLabel = row.querySelector('.cart-item-discount-label');
      if (isB2B) {
        if (!discountLabel) {
          discountLabel = document.createElement('span');
          discountLabel.className = 'cart-item-discount-label';
          discountLabel.style = 'font-size: 0.65rem; color: #2e7d32; font-weight: 600; margin-top: 2px; display: block;';
          row.querySelector('.cart-item-details-wrapper').appendChild(discountLabel);
        }
        discountLabel.textContent = `✓ Wholesale (${itemDiscountPercent}% Off)`;
      } else {
        if (discountLabel) discountLabel.remove();
      }
      
      // Update converted price
      const priceVal = row.querySelector('.cart-item-price-wrapper .price-val');
      if (priceVal) {
        const lineInrPrice = itemPrice * item.quantity;
        priceVal.setAttribute('data-original-price-text', `Rs. ${lineInrPrice.toFixed(2)}`);
        priceVal.textContent = `${symbol} ${convertVal(lineInrPrice)}`;
      }
      
      // Update retail compare price if B2B is active
      const compareWrapper = row.querySelector('.cart-item-price-wrapper');
      let compareVal = row.querySelector('.compare-val');
      if (isB2B) {
        if (!compareVal && compareWrapper) {
          compareVal = document.createElement('span');
          compareVal.className = 'compare-val';
          compareVal.style = 'text-decoration: line-through; color: var(--color-text-secondary); font-size: var(--font-size-xs); display: block;';
          compareWrapper.appendChild(compareVal);
        }
        if (compareVal) {
          const lineCompareInrPrice = item.price * item.quantity;
          compareVal.setAttribute('data-original-price-text', `Rs. ${lineCompareInrPrice.toFixed(2)}`);
          compareVal.textContent = `${symbol} ${convertVal(lineCompareInrPrice)}`;
        }
      } else {
        if (compareVal) {
          compareVal.remove();
        }
      }
    }
  });

  // Update prices
  const formattedSubtotal = `${symbol} ${convertVal(computedSubtotal)}`;
  const formattedTotal = `${symbol} ${convertVal(computedTotal)}`;
  const formattedDiscount = `-${symbol} ${convertVal(computedDiscount)}`;
  
  subtotalElems.forEach(elem => {
    elem.setAttribute('data-original-price-text', `Rs. ${computedSubtotal.toFixed(2)}`);
    elem.textContent = formattedSubtotal;
  });
  totalElems.forEach(elem => {
    elem.setAttribute('data-original-price-text', `Rs. ${computedTotal.toFixed(2)}`);
    elem.textContent = formattedTotal;
  });
  discountElems.forEach(elem => {
    elem.setAttribute('data-original-price-text', `Rs. ${computedDiscount.toFixed(2)}`);
    elem.textContent = formattedDiscount;
    if (computedDiscount > 0) {
      elem.style.color = '#2e7d32';
    } else {
      elem.style.color = 'var(--color-success)';
    }
  });

  // Update Free Shipping Progress
  if (shippingBar && shippingText) {
    if (computedSubtotal === 0) {
      shippingBar.style.width = '0%';
      shippingText.innerHTML = `Add items of <strong>${symbol} ${convertVal(FREE_SHIPPING_THRESHOLD)}</strong> to unlock FREE EXPRESS SHIPPING`;
    } else if (computedSubtotal >= FREE_SHIPPING_THRESHOLD) {
      shippingBar.style.width = '100%';
      shippingBar.style.backgroundColor = 'var(--color-accent-gold)';
      shippingText.innerHTML = `🎉 You have unlocked <strong>FREE EXPRESS SHIPPING!</strong>`;
    } else {
      const remaining = FREE_SHIPPING_THRESHOLD - computedSubtotal;
      const percentage = (computedSubtotal / FREE_SHIPPING_THRESHOLD) * 100;
      shippingBar.style.width = `${percentage}%`;
      shippingBar.style.backgroundColor = 'var(--color-dark-navy)';
      shippingText.innerHTML = `You are only <strong>${symbol} ${convertVal(remaining)}</strong> away from <strong>FREE EXPRESS SHIPPING</strong>`;
    }
  }

  // Update Currency Warning Notice Boxes (Cart Page & Cart Drawer)
  const warningPageBox = document.querySelector('.cart-currency-warning-box');
  const warningDrawerBox = document.querySelector('.cart-currency-warning-box-drawer');
  
  if (targetCurrency !== 'INR' && computedTotal > 0) {
    const formattedConverted = `${targetCurrency} ≈ ${symbol} ${convertVal(computedTotal)}`;
    const formattedInr = computedTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    
    if (warningPageBox) {
      warningPageBox.style.display = 'block';
      const convEl = warningPageBox.querySelector('.warning-converted-total');
      const inrEl = warningPageBox.querySelector('.warning-inr-total');
      if (convEl) convEl.textContent = formattedConverted;
      if (inrEl) inrEl.textContent = formattedInr;
    }
    
    if (warningDrawerBox) {
      warningDrawerBox.style.display = 'block';
      const convEl = warningDrawerBox.querySelector('.warning-converted-total-drawer');
      const inrEl = warningDrawerBox.querySelector('.warning-inr-total-drawer');
      if (convEl) convEl.textContent = formattedConverted;
      if (inrEl) inrEl.textContent = formattedInr;
    }
  } else {
    if (warningPageBox) warningPageBox.style.display = 'none';
    if (warningDrawerBox) warningDrawerBox.style.display = 'none';
  }
}

/**
 * Premium Sticky Header & Mega Menu Actions
 */
function initMegaMenu() {
  const header = document.querySelector('.luxury-header-sticky');
  const megaMenus = document.querySelectorAll('.mega-menu-panel');

  // Dynamically map trigger attribute to collections/jewelry/catalog links
  const navLinks = document.querySelectorAll('.desktop-nav-link');
  navLinks.forEach(link => {
    const text = link.textContent.trim().toLowerCase();
    if (text.includes('jewelry') || text.includes('collections') || text.includes('catalog') || text.includes('shop')) {
      if (!link.hasAttribute('data-mega-menu-trigger')) {
        link.setAttribute('data-mega-menu-trigger', 'mega-menu-jewelry');
      }
    }
  });

  const megaMenuLinks = document.querySelectorAll('[data-mega-menu-trigger]');

  window.addEventListener('scroll', () => {
    if (window.scrollY > 40) {
      header?.classList.add('header-scrolled');
    } else {
      header?.classList.remove('header-scrolled');
    }
  });

  megaMenuLinks.forEach(link => {
    link.addEventListener('mouseenter', () => {
      const menuId = link.getAttribute('data-mega-menu-trigger');
      const targetMenu = document.getElementById(menuId) || document.getElementById('mega-menu-jewelry');
      
      megaMenus.forEach(menu => menu.classList.remove('active'));
      if (targetMenu) {
        targetMenu.classList.add('active');
        document.querySelector('.header-overlay')?.classList.add('active');
      }
    });
  });

  const headerContainer = document.querySelector('.luxury-header-sticky');
  headerContainer?.addEventListener('mouseleave', () => {
    megaMenus.forEach(menu => menu.classList.remove('active'));
    document.querySelector('.header-overlay')?.classList.remove('active');
  });

  // Handle escape to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      megaMenus.forEach(menu => menu.classList.remove('active'));
      document.querySelector('.header-overlay')?.classList.remove('active');
      closeAllDrawers();
    }
  });
}

/**
 * Premium Search Overlay & Predictive Typing
 */
function initSearchOverlay() {
  const searchOverlay = document.getElementById('search-overlay');
  const searchTriggers = document.querySelectorAll('[data-search-trigger]');
  const searchClose = document.querySelector('.search-overlay-close');
  const searchInput = document.querySelector('.search-overlay-input');
  const resultsContainer = document.querySelector('.search-predictive-results');

  searchTriggers.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      searchOverlay?.classList.add('active');
      setTimeout(() => searchInput?.focus(), 150);
      document.body.classList.add('overflow-hidden');
    });
  });

  searchClose?.addEventListener('click', () => {
    searchOverlay?.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  });

  // Mock Predictive search
  searchInput?.addEventListener('input', (e) => {
    const value = e.target.value.trim().toLowerCase();
    if (value.length < 2) {
      if (resultsContainer) resultsContainer.innerHTML = '';
      return;
    }

    // Simulated lookup
    const products = [
      { title: 'Diamond Solitaire Pendant', price: '₹24,999', img: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&q=80&w=200' },
      { title: 'DeVAR Chronograph Watch', price: '₹22,999', img: 'https://images.unsplash.com/photo-1522312346375-d1a52e2b99b3?auto=format&fit=crop&q=80&w=200' },
      { title: 'Classic Diamond Studs', price: '₹19,999', img: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?auto=format&fit=crop&q=80&w=200' },
      { title: 'Quilted Shoulder Bag', price: '₹9,999', img: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?auto=format&fit=crop&q=80&w=200' }
    ];

    const filtered = products.filter(p => p.title.toLowerCase().includes(value));

    if (resultsContainer) {
      if (filtered.length === 0) {
        resultsContainer.innerHTML = `<p class="body-sub" style="padding: var(--spacing-md) 0;">No results found for "${value}"</p>`;
      } else {
        resultsContainer.innerHTML = `
          <h5 style="margin-bottom: var(--spacing-sm); text-transform: uppercase; font-size: 0.75rem; letter-spacing: 0.05em;">Suggested Products</h5>
          <div style="display: flex; flex-direction: column; gap: var(--spacing-sm);">
            ${filtered.map(p => `
              <a href="/products/mock" style="display: flex; gap: var(--spacing-md); align-items: center;">
                <div style="width: 50px; aspect-ratio: 1; overflow: hidden; border: 1px solid var(--color-border);">
                  <img src="${p.img}" style="width: 100%; height: 100%; object-fit: cover;">
                </div>
                <div>
                  <div style="font-size: var(--font-size-sm); font-weight: 500;">${p.title}</div>
                  <div class="text-gold" style="font-size: var(--font-size-xs);">${p.price}</div>
                </div>
              </a>
            `).join('')}
          </div>
        `;
      }
    }
  });
}

/**
 * Collapsible Accordions (FAQ, product tabs)
 */
function initAccordions() {
  document.addEventListener('click', (e) => {
    const header = e.target.closest('.accordion-header');
    if (!header) return;

    const item = header.closest('.accordion-item');
    const siblingItems = item?.parentElement?.querySelectorAll('.accordion-item') || [];

    siblingItems.forEach(el => {
      if (el !== item) {
        el.classList.remove('active');
      }
    });

    item?.classList.toggle('active');
  });
}

/**
 * Wishlist System
 */
let wishlistState = [];

try {
  wishlistState = JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY)) || [];
} catch (e) {
  wishlistState = [];
}

function saveWishlist() {
  localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(wishlistState));
  updateWishlistUI();
}

function initWishlistSystem() {
  // Sync page icons initially
  updateWishlistUI();

  document.addEventListener('click', (e) => {
    const wishlistBtn = e.target.closest('[data-wishlist-toggle]');
    if (wishlistBtn) {
      e.preventDefault();
      const productId = wishlistBtn.getAttribute('data-wishlist-toggle');
      toggleWishlistItem(productId);
    }
  });
}

function toggleWishlistItem(id) {
  const index = wishlistState.indexOf(id);
  if (index > -1) {
    wishlistState.splice(index, 1);
  } else {
    wishlistState.push(id);
  }
  saveWishlist();
}

function updateWishlistUI() {
  // Update heart active states
  const wishlistButtons = document.querySelectorAll('[data-wishlist-toggle]');
  wishlistButtons.forEach(btn => {
    const id = btn.getAttribute('data-wishlist-toggle');
    if (wishlistState.includes(id)) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });

  // Update counts
  const counts = document.querySelectorAll('.wishlist-count');
  counts.forEach(count => {
    count.textContent = wishlistState.length;
    count.style.display = wishlistState.length > 0 ? 'flex' : 'none';
  });

  // Custom wishlist page renderer (real Shopify products fetch with mock fallback)
  const wishlistGrid = document.querySelector('.wishlist-page-grid');
  if (wishlistGrid) {
    if (wishlistState.length === 0) {
      wishlistGrid.innerHTML = `
        <div class="text-center" style="grid-column: 1 / -1; padding: var(--spacing-3xl) 0;">
          <h3 style="margin-bottom: var(--spacing-md);">Your wishlist is empty</h3>
          <p class="body-sub" style="margin-bottom: var(--spacing-lg);">Add items to your wishlist to see them here.</p>
          <a href="/collections/all" class="btn btn-primary"><span>Explore Products</span></a>
        </div>
      `;
    } else {
      wishlistGrid.innerHTML = `
        <div class="text-center" style="grid-column: 1 / -1; padding: var(--spacing-3xl) 0;">
          <p class="body-sub">Loading your wishlist items...</p>
        </div>
      `;
      
      fetch('/products.json?limit=250')
        .then(res => res.json())
        .then(data => {
          const matched = [];
          data.products.forEach(prod => {
            const hasMatchedVariant = prod.variants.some(v => wishlistState.includes(v.id.toString()));
            const isMatchedProduct = wishlistState.includes(prod.id.toString());
            if (hasMatchedVariant || isMatchedProduct) {
              matched.push(prod);
            }
          });
          
          if (matched.length === 0) {
            renderMockWishlistItems(wishlistGrid);
          } else {
            renderRealWishlistItems(wishlistGrid, matched);
          }
        })
        .catch(err => {
          console.error("Error loading wishlist products:", err);
          renderMockWishlistItems(wishlistGrid);
        });
    }
  }
}

function renderRealWishlistItems(grid, products) {
  const targetCountry = localStorage.getItem('devar-selected-country') || 'IN';
  const targetCurrency = (typeof countryToCurrencyMap !== 'undefined' ? countryToCurrencyMap[targetCountry] : '') || 'INR';
  const symbol = (typeof currencySymbols !== 'undefined' ? currencySymbols[targetCurrency] : '') || '₹';
  
  grid.innerHTML = products.map(prod => {
    const variant = prod.variants[0];
    const price = variant ? parseFloat(variant.price) : 259;
    const comparePrice = variant ? parseFloat(variant.compare_at_price) : 0;
    const url = `/products/${prod.handle}`;
    const title = prod.title;
    const vendor = prod.vendor || 'DeVAR';
    const imageUrl = prod.images[0] ? prod.images[0].src : 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&q=80&w=400';
    const id = variant ? variant.id.toString() : prod.id.toString();
    
    const comparePriceHtml = comparePrice > price 
      ? `<span class="compare-val" style="text-decoration: line-through; color: var(--color-text-secondary); font-size: var(--font-size-xs); margin-right: 6px;">Rs. ${comparePrice.toFixed(2)}</span>`
      : '';
      
    return `
      <div class="product-card" data-product-id="${id}" style="position: relative; display: flex; flex-direction: column; height: 100%; border: 1px solid var(--color-border); background-color: var(--color-bg-white); padding: 0 0 var(--spacing-md) 0;">
        <div class="product-card-image-wrap" style="position: relative; aspect-ratio: 1; overflow: hidden; width: 100%; background: var(--color-bg-secondary);">
          <a href="${url}" class="product-card-link-wrapper" style="width: 100%; height: 100%; display: block;">
            <img class="product-card-img primary" src="${imageUrl}" alt="${title}" style="width: 100%; height: 100%; object-fit: cover;">
          </a>
          <button class="product-card-wishlist-btn active" aria-label="Remove from wishlist" data-wishlist-toggle="${id}" style="position: absolute; top: var(--spacing-sm); right: var(--spacing-sm); z-index: 10; background: none; border: none; cursor: pointer; padding: 6px;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="#D93838" viewBox="0 0 24 24" stroke-width="1.5" stroke="#D93838" style="width: 20px; height: 20px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
            </svg>
          </button>
        </div>
        <div class="product-card-details" style="padding: var(--spacing-md); display: flex; flex-direction: column; flex-grow: 1;">
          <span class="product-card-vendor" style="font-size: var(--font-size-xs); color: var(--color-text-secondary); text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 4px;">${vendor}</span>
          <h4 class="product-card-title" style="font-family: var(--font-family-heading); font-size: var(--font-size-md); font-weight: 500; margin-bottom: var(--spacing-xs); line-height: 1.4;">
            <a href="${url}" style="color: var(--color-text-primary); text-decoration: none;">${title}</a>
          </h4>
          <div class="product-card-price-wrap" style="margin-top: auto; display: flex; align-items: baseline;">
            ${comparePriceHtml}
            <span class="price-val product-card-price" style="font-weight: 600; color: var(--color-text-primary);">Rs. ${price.toFixed(2)}</span>
          </div>
        </div>
      </div>
    `;
  }).join('');
  
  if (typeof convertAllPricesOnPage === 'function') {
    convertAllPricesOnPage();
  }
}

function renderMockWishlistItems(grid) {
  const mockProducts = [
    {
      id: "mock-1",
      handle: "16-in-1-manicure-pedicure-grooming-kit-with-nail-clippers-sc",
      title: "16 in 1 Manicure Pedicure Grooming Kit",
      vendor: "LAKSHIV",
      variants: [{ id: "mock-1", price: "399.00", compare_at_price: "599.00" }],
      images: [{ src: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&q=80&w=400" }]
    },
    {
      id: "mock-2",
      handle: "classic-diamond-studs",
      title: "Classic Diamond Studs",
      vendor: "DeVAR Luxe",
      variants: [{ id: "mock-2", price: "199.00", compare_at_price: "299.00" }],
      images: [{ src: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?auto=format&fit=crop&q=80&w=400" }]
    }
  ];
  
  const filteredMocks = mockProducts.filter(p => wishlistState.includes(p.id) || wishlistState.some(id => p.handle.includes(id)));
  
  if (filteredMocks.length === 0) {
    renderRealWishlistItems(grid, mockProducts);
  } else {
    renderRealWishlistItems(grid, filteredMocks);
  }
}

/**
 * Pulsing Product Hotspots
 */
function initProductHotspots() {
  const hotspots = document.querySelectorAll('.hotspot-pin');

  hotspots.forEach(pin => {
    pin.addEventListener('click', (e) => {
      e.stopPropagation();
      const cardId = pin.getAttribute('data-hotspot-card');
      const allPopups = document.querySelectorAll('.hotspot-card-popup');
      const targetPopup = document.getElementById(cardId);
      
      allPopups.forEach(pop => {
        if (pop !== targetPopup) pop.classList.remove('active');
      });
      
      targetPopup?.classList.toggle('active');
    });
  });

  document.addEventListener('click', () => {
    document.querySelectorAll('.hotspot-card-popup').forEach(pop => pop.classList.remove('active'));
  });
}

/**
 * Product Options/Variants
 */
function initProductVariants() {
  const options = document.querySelectorAll('.variant-swatch');

  options.forEach(swatch => {
    swatch.addEventListener('click', () => {
      const parentGroup = swatch.closest('.variant-group');
      parentGroup?.querySelectorAll('.variant-swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
      
      // Simulates price recalculation based on combination selections
      // Dispatch variant selection event for local sandbox environment
      const groupName = parentGroup?.getAttribute('data-group-name');
      const value = swatch.getAttribute('data-value');
      
      document.dispatchEvent(new CustomEvent('variantChanged', { detail: { groupName, value } }));
    });
  });
}

/**
 * Drawer Toggle Listeners (Mobile menu drawer, Cart drawer, filter sheets)
 */
function initDrawerTriggers() {
  document.addEventListener('click', (e) => {
    // Menu Drawer
    const menuTrigger = e.target.closest('[data-drawer-trigger]');
    if (menuTrigger) {
      const drawerId = menuTrigger.getAttribute('data-drawer-trigger');
      const drawer = document.getElementById(drawerId);
      const overlay = document.getElementById('drawer-overlay');
      if (drawer && overlay) {
        drawer.classList.add('active');
        overlay.classList.add('active');
        document.body.classList.add('overflow-hidden');
        if (drawerId === 'mobile-menu-drawer') {
          document.querySelector('.luxury-header-sticky')?.classList.add('drawer-open');
        }
      }
    }

    // Close drawers
    const closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn || e.target.id === 'drawer-overlay') {
      closeAllDrawers();
    }
  });
}
